import { render, staticRenderFns } from "./tenderDepartment.vue?vue&type=template&id=4941f013"
import script from "./tenderDepartment.vue?vue&type=script&lang=js"
export * from "./tenderDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports